import React, { useState } from "react";

import {
  APIProvider,
  ControlPosition,
  Map,
  MapControl,
} from "@vis.gl/react-google-maps";
import DrawLocations from "../Assets/DrawLocations";
import PlacesSearch from "./PlacesSearch";
import Clusters from "../Maps/Clusters";
import { MapFilterType } from "../Maps/MapFilters";
import { useRemoveLocationFromContactsMutation } from "../store/slices/mapsSlice";
import { toast } from "react-toastify";

export default function ContactLocationMap({
  setMarkerOverlay,
  contactUuid,
  setAddress,
}: {
  setMarkerOverlay: (overlay: any) => void;
  setAddress: (address: string) => void;
  contactUuid: string;
}) {
  const [filters, setFilters] = useState<MapFilterType>({
    Contacts: true,
    Assets: false,
    ContactUuids: [contactUuid],
    Direct: true,
    Indirect: false,
  });

  const [locations, setLocations] = useState<any[]>([]);
  const [removeLocationFromContacts] = useRemoveLocationFromContactsMutation();

  return (
    <APIProvider apiKey={(window as any).GM_API_KEY} version="3.64">
      <Map
        mapId="map"
        style={{ height: 300 }}
        defaultBounds={{
          north: 60,
          south: 40,
          east: 10,
          west: -10,
        }}
        gestureHandling="greedy"
        disableDefaultUI
      >
        <MapControl position={ControlPosition.TOP_CENTER} />
      </Map>
      <PlacesSearch
        setAddress={setAddress}
        onAdd={(marker) => {
          setMarkerOverlay((p: any) => {
            p?.setMap(null);
            return marker;
          });
        }}
      />
      {contactUuid && <Clusters filters={filters} onLoad={setLocations} />}
      <DrawLocations
        onAdd={(marker) => {
          setMarkerOverlay((p: any) => {
            p?.setMap(null);
            return marker;
          });
        }}
        drawingModes={["marker"]}
      />
      {locations.length > 0 ? (
        <button
          type="button"
          title="Delete contact location"
          className="btn btn-colored"
          onClick={() =>
            removeLocationFromContacts({
              contactUuids: [contactUuid],
            }).then((res: any) => {
              if (res.error) {
                toast.error("Failed to remove location");
              } else {
                toast.success("Removed location successfully");
              }
            })
          }
        >
          Delete contact location
        </button>
      ) : (
        ""
      )}
    </APIProvider>
  );
}
